
const eLoader = {
	props: {
		absolute: {
			type: String,
			required: false,
			default: false,
		},
	},
	mounted: function () {
	},
	template: `<div class="e-loader" :class="{ 'is-absolute': absolute === 'true' }"></div>`,
}

